// eslint-disable-next-line no-use-before-define
import React, { Fragment, useContext } from 'react';
import UserContext, { UserContextType } from '../../contexts/UserContext/UserContext';
import { PermissionType } from 'op-enums';

import ROSidePatientNav from './ROSidePatientNav';
import PSOSidePatientNav from 'op-components/SideNav/PSOSidePatientNav';
import NurseSidePatientNav from './NurseSidePatientNav';

interface Props {
  patientId: any;
  refreshChartSummary?: any;
  createManagementPlan?: any;
  createReferralExistingService?: any;
  disableCreateButton?: boolean;
  showButtons?: boolean;
  $collapsed?: boolean;
  className?: string;
}

const SidePatientNav = (props: Props): JSX.Element => {
  const { hasPermission } = useContext<UserContextType>(UserContext);

  if (hasPermission(PermissionType.RADIATION_ACCESS)) {
    return <ROSidePatientNav {...props} />;
  }
  if (hasPermission(PermissionType.PSO_ACCESS)) {
    return <PSOSidePatientNav {...props} />;
  }
  if (hasPermission(PermissionType.NURSE_ACCESS)) {
    return <NurseSidePatientNav {...props} />;
  }
  return <Fragment />;
};

export default SidePatientNav;
